import { observable } from "mobx";
import PatchNotes from "../modules/PatchNotes/PatchNotes";
import { componentService, patchNotes } from "../_services";
import { IPatch, IPatchNotes} from "../_types/interfaces";


export const patchNotesStore = observable({
    textPatchNote: "",
    isLoaded: false,

    async loadLocalPatchNotes(serviceName: string) {
        patchNotesStore.isLoaded = true;
        try {
            const response = await patchNotes.getLocalPatchNotes(serviceName);

            patchNotesStore.textPatchNote = response;
        } catch (errors) 
        {
            patchNotesStore.textPatchNote = "";
            console.log(errors);
        }
        patchNotesStore.isLoaded = false;
    },

    async loadGlobalPatchNote(serviceName: string) {
        patchNotesStore.isLoaded = true;
        try {
            const url = await componentService.getAddress();
            const response = await patchNotes.getGlobalPatchNote(url, serviceName);

            patchNotesStore.textPatchNote = response;
        } catch (errors) 
        {
            patchNotesStore.textPatchNote = "";
            console.log(errors);
        }
        patchNotesStore.isLoaded = false;
    },

    async loadLocalPatchNotesService(serviceName: string) {
        patchNotesStore.isLoaded = true;
        try {
            const response = await patchNotes.getLocalPatchNotesService(serviceName);

            patchNotesStore.textPatchNote = response;
        } catch (errors) 
        {
            patchNotesStore.textPatchNote = "";
            console.log(errors);
        }
        patchNotesStore.isLoaded = false;
    },

    async loadLocalPatchNotesPlugin(pluginName: string) {
        patchNotesStore.isLoaded = true;
        try {
            const response = await patchNotes.getLocalPatchNotesPlugin(pluginName);

            patchNotesStore.textPatchNote = response;
        } catch (errors) 
        {
            patchNotesStore.textPatchNote = "";
            console.log(errors);
        }
        patchNotesStore.isLoaded = false;
    },

});
